/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoMissionFreeLogListMissionFreeLogData model module.
 * @module model/LogControllerDtoMissionFreeLogListMissionFreeLogData
 * @version 1.0
 */
class LogControllerDtoMissionFreeLogListMissionFreeLogData {
    /**
     * Constructs a new <code>LogControllerDtoMissionFreeLogListMissionFreeLogData</code>.
     * @alias module:model/LogControllerDtoMissionFreeLogListMissionFreeLogData
     */
    constructor() { 
        
        LogControllerDtoMissionFreeLogListMissionFreeLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoMissionFreeLogListMissionFreeLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoMissionFreeLogListMissionFreeLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoMissionFreeLogListMissionFreeLogData} The populated <code>LogControllerDtoMissionFreeLogListMissionFreeLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoMissionFreeLogListMissionFreeLogData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('missionNo')) {
                obj['missionNo'] = ApiClient.convertToType(data['missionNo'], 'Number');
            }
            if (data.hasOwnProperty('missionType')) {
                obj['missionType'] = ApiClient.convertToType(data['missionType'], 'Number');
            }
            if (data.hasOwnProperty('missionIndex')) {
                obj['missionIndex'] = ApiClient.convertToType(data['missionIndex'], 'Number');
            }
            if (data.hasOwnProperty('missionStatus')) {
                obj['missionStatus'] = ApiClient.convertToType(data['missionStatus'], 'Boolean');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoMissionFreeLogListMissionFreeLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoMissionFreeLogListMissionFreeLogData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} logNo
 */
LogControllerDtoMissionFreeLogListMissionFreeLogData.prototype['logNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoMissionFreeLogListMissionFreeLogData.prototype['accountNo'] = undefined;

/**
 * @member {Number} missionNo
 */
LogControllerDtoMissionFreeLogListMissionFreeLogData.prototype['missionNo'] = undefined;

/**
 * @member {Number} missionType
 */
LogControllerDtoMissionFreeLogListMissionFreeLogData.prototype['missionType'] = undefined;

/**
 * @member {Number} missionIndex
 */
LogControllerDtoMissionFreeLogListMissionFreeLogData.prototype['missionIndex'] = undefined;

/**
 * @member {Boolean} missionStatus
 */
LogControllerDtoMissionFreeLogListMissionFreeLogData.prototype['missionStatus'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoMissionFreeLogListMissionFreeLogData.prototype['createdAt'] = undefined;






export default LogControllerDtoMissionFreeLogListMissionFreeLogData;

